import React, { useState, useEffect } from "react";
import clock from "../assets/clock.png"; // Cashback icon
import img1 from "../assets/img1.png";
import img2 from "../assets/img2.png";
import img3 from "../assets/img3.png";
import xbLogo from "../assets/xblogo.png";
import xbEnergy from "../assets/xblogo.png";
import giftemoji from "../assets/giftemoji.png";
import giftXB from "../assets/gift-xb.png";
import receXB from "../assets/Rectangle 22154 (2).png";



import Navbar from "./Navbar";
import XboxCheckout from "./XboxCheckout";
import Login from "./Login"; // Import Login component
import GuestPop from "./GuestPop"; // Import Login component
import { useNavigate } from "react-router-dom";

import api from "../utils/api";
import { usePricing } from "../context/PricingContext";
import { useAuth } from "../context/AuthContext"; // Import AuthContext

const getCurrencySymbol = (currency) => {
  const symbols = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    PKR: "₨",
    INR: "₹",
    CAD: "C$",
    SAR: "SAR", // Added symbol for SAR (Saudi Riyal)
    AUD: "A",
  };

  return symbols[currency] || currency; // Fallback to showing the currency code if symbol not found
};

const XboxCoins = () => {
  const navigate = useNavigate();

  const [userId, setUserId] = useState(null);
  const [isNewCustomer, setIsNewCustomer] = useState(null); // null = loading, true/false = loaded
  const { currency, prices } = usePricing(); // Use global pricing context
  const { token } = useAuth(); // Use Auth context
  const currencySymbol = getCurrencySymbol(currency); // Get the symbol for the current currency
  const [quantity, setQuantity] = useState(100); // Quantity in thousands
  const [cashback, setCashback] = useState(0); // Cashback amount
  const [showTooltip, setShowTooltip] = useState(false);
  const [showCheckout, setShowCheckout] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false); // State for login popup
  const [amount, setAmount] = useState(0);
  const [cashbackRate, setCashbackRate] = useState(0); // Temporary variable for cashback rate
  const [gatewayFees, setGatewayFees] = useState(0.03); // Set to 5%
  const [guestCheckout, setGuestCheckout] = useState(false); // State to handle guest checkout
  const [showGuestPop, setShowGuestPop] = useState(false)

  const sliderSteps = [
    { value: 100, label: "100K" },
    { value: 1500, label: "1.5M" },
    { value: 3000, label: "3M" },
    { value: 4500, label: "4.5M" },
    { value: 6000, label: "6M" },
    { value: 7500, label: "7.5M" },
    { value: 9000, label: "9M" },
    { value: 10000, label: "10M" },

  ];

  useEffect(() => {
    const fetchUserAndCheckOrders = async () => {
      // For guests, show bonus by default
      if (!token) {
        setIsNewCustomer(true);
        return;
      }

      try {
        // Fetch user ID first
        const userResponse = await api.get(`${process.env.REACT_APP_API_BASE_URL}/users/me`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        const userId = userResponse.data?._id;
        if (!userId) {
          setIsNewCustomer(false);
          return;
        }

        setUserId(userId);

        // Then check order count
        const orderResponse = await api.get(
          `${process.env.REACT_APP_API_BASE_URL}/orders/count?userId=${userId}`
        );

        setIsNewCustomer(orderResponse.data?.count === 0);
      } catch (error) {
        console.error("Error checking customer status:", error);
        setIsNewCustomer(false);
      }
    };

    fetchUserAndCheckOrders();
  }, [token]);

  const [glowIntensity, setGlowIntensity] = useState(0.4)

  // Subtle pulsing effect for the inner glow
  useEffect(() => {
    const interval = setInterval(() => {
      setGlowIntensity((prev) => {
        const newValue = prev + (Math.random() * 0.1 - 0.05)
        return Math.max(0.3, Math.min(0.6, newValue))
      })
    }, 500)

    return () => clearInterval(interval)
  }, [])

  const calculatePosition = (value) => {
    const min = 100;
    const max = 10000;
    return ((value - min) / (max - min)) * 99;
  };
  const isValueNearStep = (currentValue, stepValue) => {
    const threshold = (stepValue >= 1000) ? 125 : 25;
    return Math.abs(currentValue - stepValue) <= threshold;
  };
  const toggleGuestPopup = () => {
    setShowGuestPop(!showGuestPop);
  };

  const handlePaymentIssue = () => {
    navigate("/payment-issue"); // Adjust the route to match your application's setup
  }


  // Fetch cashback rate
  useEffect(() => {
    const fetchCashback = async () => {
      try {
        const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/cashback`);
        if (response.data?.cashback?.value) {
          setCashbackRate(response.data.cashback.value);
        } else {
          console.error("Cashback value not found in response");
        }
      } catch (error) {
        console.error("Error fetching cashback:", error);
      }
    };

    fetchCashback();
  }, []);

  // Fetch XB price
  useEffect(() => {
    if (prices && prices.XB > 0) {
      const calculatedAmount = (prices.XB * quantity) / 100;
      setAmount(calculatedAmount);
      setCashback(calculatedAmount * cashbackRate);
    }
  }, [prices, quantity, cashbackRate]);

  // Handle quantity change
  const handleQuantityChange = (value) => {
    const quantityInK = Math.max(100, Math.min(10000, value)); // Restrict between 50K and 5000K
    setQuantity(quantityInK);

    const calculatedAmount = (quantityInK * prices.XB) / 100; // Use current XB price
    setAmount(calculatedAmount);
    setCashback(calculatedAmount * cashbackRate); // Use current cashback rate
  };

  // Handle checkout button
  const handleCheckout = () => {
    if (!token && !guestCheckout) {
      // Show GuestPop if not logged in
      setShowGuestPop(true);
    } else {
      // Proceed to checkout (can redirect to another page or process payment)
      setShowCheckout(true);
    }
  };




  // Continue as guest button functionality
  const handleContinueAsGuest = () => {
    setGuestCheckout(true); // Enable guest checkout
    setShowGuestPop(false); // Close the GuestPop
    setShowCheckout(true); // Proceed to checkout

    console.log("Continuing as guest...");
    // Additional logic for guest checkout can go here
  };


  if (showCheckout) {
    return (
      <XboxCheckout
        quantity={quantity}
        amount={amount}
        cashback={cashback}
        currency={currency} // Pass currency to XboxCheckout
        gatewayFees={amount * gatewayFees + 0.3}
      />
    );
  }

  return (
    <>
      <div className="lg:bg-black  bg-[#191919]">

        {showGuestPop && (
          <GuestPop
            onGuestCheckout={handleContinueAsGuest} // Pass guest checkout handler
          />
        )}
        <section className="lg:bg-black  bg-[#191919]  text-white min-h-screen py-10 px-4 sm:px-6 lg:px-8 lg:block hidden">
          {/* Header Section */}
          <div className="flex flex-row justify-center items-center mb-8">
            <img src={xbLogo} alt="Xbox Logo" className="w-20 mr-4" />
            <h1 className="text-3xl lg:text-7xl font-bold">XBOX Coins</h1>
          </div>

          <div className="flex items-center justify-center mb-8 bg-black">
            <div
              className="flex items-center justify-center gap-2 border-2 border-[#B6FF1C] h-[62px] w-[250px] rounded-[10px] shadow-md px-4 py-2"
              style={{
                background: "linear-gradient(to right, #FFFFFF, #B6FF1C)",
              }}
            >
              <img src={giftemoji} alt="Bonus Icon" className="w-6 h-6" />
              <span className="text-black font-inter font-bold text-[16px] italic text-center">
                Bonus <span className="text-black">+10% Coins</span>
              </span>
            </div>
          </div>




          {/* Main Card */}
          <div className="bg-[#191919] border border-[#B6FF1C] rounded-xl p-6 max-w-4xl mx-auto">
            {/* Quantity, Amount, Cashback */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 items-center text-center">
              {/* Quantity */}
              <div>
                <img src={img1} alt="Quantity" className="w-14 mx-auto mb-2" />
                <h3 className="text-lg font-bold">Quantity</h3>
                <div className="flex items-center justify-center mt-2">
                  <button
                    className="bg-white h-[72px] text-black font-bold px-3 py-4 rounded-l-lg border-r border-gray-300"
                    onClick={() => handleQuantityChange(quantity - 50)}
                  >
                    -
                  </button>
                  <div className="bg-white h-[72px] text-black px-6 py-4 font-bold flex items-center justify-center">
                    <span>{quantity}K</span>
                  </div>
                  <button
                    className="bg-white h-[72px] text-black font-bold px-3 py-4 rounded-r-lg border-l border-gray-300"
                    onClick={() => handleQuantityChange(quantity + 50)}
                  >
                    +
                  </button>

                  <div className="flex">
                    <img src={receXB} alt="Rectangle 22154" className="w-20 h-20 ml-4" />
                    <div className="absolute text-black mt-2 font-bold text-sm ml-[44px] mb-10 mr-10">
                      <img src={giftemoji} alt="Rectangle 22154" className="w-6 h-6" />
                    </div>
                    <div className="absolute text-black font-bold text-lg ml-10 mt-8 mr-10">
                      {quantity * 0.10}K
                    </div>

                    <div className="absolute text-black font-bold text-[8px] ml-[42px] mt-[57px]">
                      Bonus
                    </div>
                  </div>

                  {/* <div
                    className="ml-2 p-[10px] w-24 rounded-lg shadow-md border border-green-400 flex flex-col items-center justify-center"
                    style={{
                      background: "linear-gradient(to right, #FFFFFF, #B6FF1C)",
                    }}
                  >
                    <span className="text-black font-bold text-base leading-tight">{quantity * 0.10}K</span>
                    <span className="text-black italic text-xs leading-tight">Bonus</span>
                  </div> */}


                </div>
              </div>

              {/* Amount */}
              <div>
                <img src={img2} alt="Amount" className="w-14 mx-auto mb-2" />
                <h3 className="text-lg font-bold">Amount</h3>
                <div className="flex items-center justify-center mt-2">
                  <div className="bg-white h-[72px] text-black px-6 py-4 rounded-lg font-bold flex items-center justify-center">
                    {`${amount.toFixed(2)} ${currencySymbol}`}
                  </div>
                </div>
              </div>

              {/* Cashback */}
              <div>
                <img src={img3} alt="Cashback" className="w-14 mx-auto mb-2" />
                <div>
                  <div className="flex items-center justify-center mb-2 relative group">
                    <h3 className="text-lg font-bold">Cashback</h3>
                    <div className="ml-2">
                      {/* Info Icon */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 text-[#B6FF1C] cursor-pointer"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-4a1 1 0 100 2 1 1 0 000-2zm1 3a1 1 0 00-2 0v4a1 1 0 102 0v-4zm-1 8a1 1 0 100 2 1 1 0 000-2z"
                          clipRule="evenodd"
                        />
                      </svg>
                      {/* Tooltip */}
                      <div className="absolute hidden group-hover:block bg-[#B6FF1C] text-black text-sm rounded-lg px-4 py-2 w-64 top-8 left-0 z-10">
                        Get <span className="font-bold">5% cashback</span> added to your account with every
                        purchase, which you can use for future orders.
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center justify-center mt-2">
                    <div className="bg-white h-[72px] text-black px-6 py-4 rounded-lg font-bold flex items-center justify-center">
                      {`${cashback.toFixed(2)} ${currencySymbol}`}
                    </div>
                  </div>

                </div>
              </div>
            </div>

            {/* Slider */}

            <div className="mt-8 mb-8 relative">
              <input
                type="range"
                min="100"
                max="10000"
                step="50"
                value={quantity}
                onChange={(e) => handleQuantityChange(parseFloat(e.target.value))}
                className="w-full h-2 appearance-none bg-white/20 rounded-lg cursor-pointer
            [&::-webkit-slider-runnable-track]:h-2
            [&::-webkit-slider-runnable-track]:rounded-full
            [&::-webkit-slider-runnable-track]:bg-white/90
            [&::-webkit-slider-thumb]:appearance-none
            [&::-webkit-slider-thumb]:w-8
            [&::-webkit-slider-thumb]:h-8
            [&::-webkit-slider-thumb]:-mt-3
            [&::-webkit-slider-thumb]:rounded-full
            [&::-webkit-slider-thumb]:bg-lime-400
            [&::-webkit-slider-thumb]:shadow-[0_0_10px_rgba(182,255,28,0.5)]
            [&::-webkit-slider-thumb]:cursor-pointer"
              />

              <div className="relative w-full mt-3 h-6">
                {sliderSteps.map((step) => (
                  <div
                    key={step.value}
                    className="absolute"
                    style={{ left: `${calculatePosition(step.value)}%` }}
                  >
                    <span
                      className={`absolute -translate-x-1/2 whitespace-nowrap ${isValueNearStep(quantity, step.value)
                        ? "text-white font-bold text-sm"
                        : "text-gray-400 text-xs"
                        }`}
                    >
                      {step.label}
                    </span>
                  </div>
                ))}
              </div>
            </div>
            {/* Checkout */}
            <div className="flex items-center justify-between mt-6">
              <p className="text-[#B6FF1C] font-bold mt-6">⚡ 20 Mins</p>
              <button
                className="bg-[#B6FF1C] ml-2 mr-4 text-black font-bold px-8 py-3 rounded-lg hover:bg-yellow-300 transition mt-6"
                onClick={handleCheckout}
              // onClick={handlePaymentIssue}
              >
                Checkout
              </button>
              <p className="text-[#B6FF1C] font-bold flex items-center space-x-2 mt-6">
                <img src={clock} alt="Clock Icon" className="w-4 h-4" />
                <span>24/7</span>
              </p>
            </div>
          </div>

          <div className="mt-6 bg-[#B6FF1C] w-[65%] ml-60 rounded-lg p-4 text-black font-inter flex items-center justify-center">
            <p className="font-bold text-[12px]">
              Requirements to order: <span className="font-normal">Unlocked web/companion app transfer market, 1500 coins, and less than 5 unassigned items.</span>
            </p>
          </div>


        </section>



        <section className="lg:hidden bg-[#191919] text-white border border-[#B6FF1C] rounded-3xl py-8 px-4 mr-8 ml-8">
          {/* Header Section */}
          <div className="flex flex-col items-center mb-6">
            <img src={xbLogo} alt="Xbox Logo" className="w-16 mb-4" />
            <h1 className="text-2xl font-bold text-center">XBOX Coins</h1>
          </div>

          {/* Main Card */}
          <div className="bg-[#1A1A1A]  flex flex-col items-center w-full">
            <div className="space-y-6 w-full">
              {/* Quantity */}
              <div className="flex flex-col items-center w-full">
                <div className="flex items-center justify-center w-full">
                  {/* Icon */}
                  <img src={img1} alt="Quantity" className="w-12 mr-4" />

                  {/* Heading and Input */}
                  <div className="flex flex-col items-center justify-center">
                    <h3 className="text-xs font-inter font-bold mb-2">Quantity</h3>

                    {/* Quantity Selector */}
                    <div className="flex items-center">
                      <button
                        className="bg-white text-black font-inter font-bold px-2 py-1 rounded-l-lg border-r border-gray-300"
                        onClick={() => handleQuantityChange(quantity - 50)}
                      >
                        -
                      </button>
                      <div className="bg-white text-black px-4 py-1 font-bold w-[90px] text-center">
                        {quantity}K
                      </div>
                      <button
                        className="bg-white text-black font-inter font-bold px-2 py-1 rounded-r-lg border-l border-gray-300"
                        onClick={() => handleQuantityChange(quantity + 50)}
                      >
                        +
                      </button>
                    </div>



                    {/* Bonus 100K Label */}

                    <div className="mt-2 px-3 py-1 rounded-md w-[140px] bg-[#B6FF1C] bg-opacity-40 text-[#B6FF1C] font-extrabold text-[11px] flex items-center">
                      <img src={giftXB} alt="Bonus Icon" className="w-5 h-5 mr-2" />
                      <div
                        className="flex flex-col mr-2 font-extrabold"
                        style={{ fontSize: "7.5px", lineHeight: "1" }}
                      >

                        <span>Bonus</span>
                        <span>Coins</span>
                      </div>
                      <span className="text-[12px] ml-5 font-bold">+{quantity * 0.10}K</span>
                    </div>

                  </div>

                </div>
              </div>

              {/* Amount */}
              <div className="flex flex-col items-center w-full">
                <div className="flex items-center justify-center w-full">
                  {/* Icon */}
                  <img src={img2} alt="Amount" className="w-12 mr-4" />

                  {/* Heading and Input */}
                  <div className="flex flex-col items-center">
                    <h3 className="text-xs font-inter font-bold mb-2">Amount</h3>
                    <div className="bg-white text-black px-4 py-1 rounded-lg font-inter font-bold w-[150px] text-center">
                      {`${amount.toFixed(2)} ${currencySymbol}`}
                    </div>
                  </div>
                </div>
              </div>

              {/* Cashback */}
              <div className="flex flex-col items-center w-full">
                <div className="flex items-center justify-center w-full">
                  {/* Icon */}
                  <img src={img3} alt="Cashback" className="w-12 mr-4" />

                  {/* Heading and Input */}
                  <div className="flex flex-col items-center relative group">
                    <h3 className="text-xs font-inter font-bold mb-2 flex items-center space-x-2">
                      <span>Cashback</span>
                      <i
                        className="fas fa-info-circle cursor-pointer"
                        style={{ color: "#B6FF1C" }}
                      ></i>
                    </h3>
                    <div className="bg-white text-black px-4 py-1 rounded-lg font-inter font-bold w-[150px] text-center">
                      {`${cashback.toFixed(2)} ${currencySymbol}`}
                    </div>

                    {/* Tooltip */}
                    <div className="absolute hidden group-hover:block bg-[#B6FF1C] text-black text-sm rounded-lg p-6  w-64 left-11 transform -translate-x-1/2 -top-32 z-10">
                      Get <span className="font-bold">5% cashback</span> added to your account
                      with every purchase, which you can use for future orders.
                    </div>

                  </div>


                </div>
              </div>
            </div>

            {/* Slider */}
            <div className="w-full flex justify-center mt-10 mb-5">
              <input
                type="range"
                min="100"
                max="10000"
                step="50"
                value={quantity}
                onChange={(e) => handleQuantityChange(parseFloat(e.target.value))}
                className="w-[90%] h-2 appearance-none rounded-lg cursor-pointer
      [&::-webkit-slider-runnable-track]:h-2
      [&::-webkit-slider-runnable-track]:rounded-full
      [&::-webkit-slider-runnable-track]:bg-white/90
      [&::-webkit-slider-thumb]:appearance-none
      [&::-webkit-slider-thumb]:w-6
      [&::-webkit-slider-thumb]:h-6
      [&::-webkit-slider-thumb]:-mt-2
      [&::-webkit-slider-thumb]:rounded-full
      [&::-webkit-slider-thumb]:bg-[#B6FF1C]
      [&::-webkit-slider-thumb]:shadow-[0_0_10px_rgba(182,255,28,0.5)]
      [&::-webkit-slider-thumb]:cursor-pointer
      [&::-moz-range-track]:h-2
      [&::-moz-range-track]:rounded-full
      [&::-moz-range-track]:bg-white/90
      [&::-moz-range-thumb]:w-6
      [&::-moz-range-thumb]:h-6
      [&::-moz-range-thumb]:border-none
      [&::-moz-range-thumb]:rounded-full
      [&::-moz-range-thumb]:bg-[#B6FF1C]
      [&::-moz-range-thumb]:shadow-[0_0_10px_rgba(182,255,28,0.5)]
      [&::-moz-range-thumb]:cursor-pointer"
              />
            </div>

            {/* Slider Labels */}
            <div className="w-[90%] mx-auto flex justify-between text-gray-400 relative mb-8">
              {[
                { value: 100, label: "100K" },
                { value: 2000, label: "2M" },
                { value: 4000, label: "4M" },
                { value: 6000, label: "6M" },
                { value: 8000, label: "8M" },
                { value: 10000, label: "10M" },
              ].map((step, index) => (
                <span
                  key={index}
                  className={`absolute text-[10px] transform -translate-x-1/2 ${isValueNearStep(quantity, step.value) ? "text-white font-bold" : ""
                    }`}
                  style={{
                    left: `${calculatePosition(step.value)}%`,
                  }}
                >
                  {step.label}
                </span>
              ))}
            </div>





            {/* Checkout */}
            <div className="flex items-center justify-center mt-6 space-x-6 w-full">
              {/* 20 Mins */}
              <div className="flex items-center text-center">
                <p className="text-[#B6FF1C] font-bold font-inter whitespace-nowrap">⚡ 20 Mins</p>
              </div>

              {/* Checkout Button */}
              <button
                className="bg-[#B6FF1C] text-black font-bold px-6 py-2 rounded-lg hover:bg-[#a3e619] transition font-inter"
                onClick={handleCheckout}
              // onClick={handlePaymentIssue}
              >
                Checkout
              </button>

              <div className="flex items-center text-center">
                <img src={clock} alt="Clock Icon" className="w-4 h-4 mr-1" />
                <p className="text-[#B6FF1C] font-bold font-inter whitespace-nowrap mr-6"> 24/7</p>
              </div>
            </div>

            {/* Requirements */}
            <div className="w-[90%] mt-6 bg-[#B6FF1C] rounded-2xl py-1 px-2 text-black text-center ">
              <p className="font-bold text-[10px] font-inter ">Requirements to order:</p>
              <p className="text-[9px] leading-relaxed font-inter">
                Unlocked web/companion app transfer market,
              </p>
              <p className="text-[9px] leading-relaxed font-inter">
                1500 coins, and less than 5 unassigned items.
              </p>
            </div>

          </div>



          {/* Requirements */}

        </section>
      </div>


    </>
  );
};

export default XboxCoins;
